import { render, staticRenderFns } from "./CompaniesEdit.vue?vue&type=template&id=4c370808&lang=pug&"
import script from "./CompaniesEdit.vue?vue&type=script&lang=ts&"
export * from "./CompaniesEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports